import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Newspaper, CalendarDays } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TAG_STYLES = {
  cyan: 'bg-cyan-500/15 border-cyan-500/40 text-cyan-300',
  green: 'bg-emerald-500/15 border-emerald-500/40 text-emerald-300',
  amber: 'bg-amber-500/15 border-amber-500/40 text-amber-300',
  red: 'bg-rose-500/15 border-rose-500/40 text-rose-300',
  purple: 'bg-purple-500/15 border-purple-500/40 text-purple-300',
};

const NewsPill = ({ item }) => (
  <span className="inline-flex items-center gap-2.5 px-4 py-1.5 mx-3 rounded-full border border-white/10 bg-[#0a1224]/80 whitespace-nowrap">
    {item.tag && (
      <span className={`px-2 py-0.5 rounded-full border text-[11px] font-bold ${TAG_STYLES[item.tag_color] || TAG_STYLES.red}`}>
        {item.tag}
      </span>
    )}
    <span className="text-white text-sm font-semibold">{item.title}</span>
    {item.text && <span className="text-orange-300 text-sm font-medium">· {item.text}</span>}
  </span>
);

export const NewsTicker = () => {
  const [news, setNews] = useState([]);
  const [speed, setSpeed] = useState(40);

  useEffect(() => {
    axios.get(`${API}/news`).then(res => setNews(res.data || [])).catch(() => {});
    axios.get(`${API}/news-settings`).then(res => setSpeed(res.data?.speed_seconds || 40)).catch(() => {});
  }, []);

  if (news.length === 0) return null;

  return (
    <div className="bg-[#060a13]" data-testid="news-ticker">
      <div className="marquee-wrap relative overflow-hidden border-y border-orange-500/25 bg-gradient-to-r from-[#0a1224] via-[#0c1526] to-[#0a1224] py-2.5">
        {/* label */}
        <div className="absolute left-0 top-0 bottom-0 z-20 flex items-center gap-2 pl-4 pr-5 bg-gradient-to-r from-[#060a13] via-[#060a13] to-transparent">
          <Newspaper className="w-4 h-4 text-orange-400 animate-pulse" />
          <span className="hidden sm:inline text-orange-300 text-xs font-bold uppercase tracking-wider">Новини</span>
        </div>
        {/* edge fades */}
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 z-10 bg-gradient-to-l from-[#060a13] to-transparent" />

        <div className="marquee-track" style={{ animationDuration: `${speed}s` }}>
          {[0, 1].map((dup) => (
            <div key={dup} className="flex items-center pl-4" aria-hidden={dup === 1}>
              {news.map((item, i) => <NewsPill key={`${dup}-${i}`} item={item} />)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsTicker;
